var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecuritySystemsLow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 98,
    viewBox: "0 0 108 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 49.4999L30.25 46.4688V52.531L19 49.4999Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7659_16535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 0H0V78H108V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7659_16535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.186 96.372C78.5893 96.372 98.372 76.5893 98.372 52.186C98.372 27.7827 78.5893 8 54.186 8C29.7827 8 10 27.7827 10 52.186C10 76.5893 29.7827 96.372 54.186 96.372Z",
    stroke: "#E8EBEF",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7659_16535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 46,
    width: 25,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46H0V78H25V46Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7659_16535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.372 52.186C98.372 76.5893 78.5893 96.372 54.186 96.372C29.7828 96.372 10 76.5893 10 52.186C10 27.7828 29.7828 8 54.186 8C78.5893 8 98.372 27.7828 98.372 52.186Z",
    stroke: "#FF0055",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 50.5001C79.8479 36.5009 68.4993 25.1523 54.5001 25.1523C40.5009 25.1523 29.1523 36.5009 29.1523 50.5001C29.1523 64.4993 40.5009 75.8479 54.5001 75.8479C68.4993 75.8479 79.8479 64.4993 79.8479 50.5001Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7659_16535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 40,
    width: 23,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7143 40H43V62.7143H65.7143V40Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7659_16535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7143 40H43V62.7143H65.7143V40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7696 44.9132L43.6134 44.374C43.4519 44.3335 43.2776 44.3784 43.1552 44.4934C43.0327 44.609 42.9774 44.7789 43.0085 44.9438L44.4898 52.8442C44.5209 53.0101 44.6345 53.1483 44.791 53.2115C44.8502 53.2352 44.9129 53.2471 44.9752 53.2471C45.0764 53.2471 45.1771 53.216 45.262 53.1552L47.0648 51.8675L45.7696 44.9132Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.008 42.0178C63.887 41.3695 63.5216 40.8071 62.9775 40.4338C62.4339 40.061 61.7762 39.9213 61.1294 40.0427L46.8641 42.6992C46.7353 42.7229 46.6212 42.797 46.5476 42.9051C46.4736 43.0133 46.4454 43.1461 46.4691 43.275L48.2768 52.9836C48.301 53.1124 48.375 53.2265 48.4832 53.3006C48.5656 53.3574 48.6634 53.387 48.7621 53.387C48.7923 53.387 48.8224 53.3845 48.8525 53.3786L65.0587 50.3606C65.3268 50.3108 65.5036 50.053 65.4542 49.7849L64.008 42.0178ZM51.5746 46.8124C51.0384 46.9121 50.5229 46.5586 50.4232 46.0223C50.3234 45.4861 50.677 44.9706 51.2132 44.8709C51.7494 44.7711 52.2649 45.1247 52.3646 45.6609C52.4649 46.1966 52.1108 46.7121 51.5746 46.8124Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2202 55.7146C64.9471 55.7146 64.7264 55.9358 64.7264 56.2083V58.6772H60.4746C59.7473 58.6772 59.1331 58.1568 59.0126 57.4339L58.2591 53.2003C58.2112 52.9322 57.9559 52.7524 57.6868 52.8008C57.4182 52.8487 57.2395 53.105 57.2869 53.3736L58.0394 57.6018C58.2384 58.7972 59.2629 59.6648 60.4746 59.6648H64.7264V61.6399C64.7264 61.9124 64.9471 62.1336 65.2202 62.1336C65.4932 62.1336 65.7139 61.9124 65.7139 61.6399V56.2083C65.7139 55.9358 65.4932 55.7146 65.2202 55.7146Z",
    fill: "#333333"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 50.5001C79.8479 36.5009 68.4993 25.1523 54.5001 25.1523C40.5009 25.1523 29.1523 36.5009 29.1523 50.5001C29.1523 64.4993 40.5009 75.8479 54.5001 75.8479C68.4993 75.8479 79.8479 64.4993 79.8479 50.5001Z",
    stroke: "#333333",
    strokeWidth: 2.30435
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecuritySystemsLow);
export default __webpack_public_path__ + "static/media/icon-security-systems-low.d9e645d2ad5f663168b2729b13fd85a4.svg";
export { ForwardRef as ReactComponent };